import { Component, EventEmitter, Input, Output } from '@angular/core';
import { GrupoEstoqueService, PosicaoEstoqueService, ProdutoService, SubGrupoEstoqueService } from 'almoxarifado-lib';
import { PlanoContaService } from 'contabil-lib';
import { BaseResourceRptComponent, Coluna, EddyAutoComplete, FuncaoService, GrupoEstoque, PlanoConta, Produto, ProgressoService, SaldoEstoqueService, Setor, SetorService, SubGrupoEstoque } from 'eddydata-lib';
import { takeUntil } from 'rxjs/operators';
import * as toastr from 'toastr';

@Component({
  selector: 'app-relatorio-posicao-estoque-rpt',
  templateUrl: './relatorio-posicao-estoque-rpt.component.html'
})
export class RelatorioPosicaoEstoqueRptComponent extends BaseResourceRptComponent {

  // ========================================================================
  // ----------------------- DECLARAÇÃO DE VARIAVEIS ------------------------
  // ========================================================================

  @Input() visualizar: boolean = false;
  @Output() visualizarChange: EventEmitter<boolean> = new EventEmitter();

  public ordenacao: { nome: string, coluna: any };
  public listaOrdenacao: { nome: string, coluna: string }[] = [];

  public geral: boolean = false;
  public geralEstoque: boolean = false;
  public analitico: boolean = false;

  public tipo: { nome: string, coluna: any };
  public listaTipo: { nome: string, coluna: string }[] = [];

  public periodo: Date;
  public exibirLoteValidade: boolean = false;
  public filtrarGrupo: boolean = false;
  public filtrarSubGrupo: boolean = false;
  public filtrarPlanoConta: boolean = false;
  public filtrarProdutos: boolean = false;
  public filtrarSetor: boolean = false;
  public grupo: GrupoEstoque = null;
  public subGrupo: SubGrupoEstoque = null;
  public setor: Setor;
  public produto: Produto;
  public listaProduto: Produto[] = [];
  public planoConta: PlanoConta;
  public utilizarGrupoSubgrupo: boolean = false;

  public grupoAutoComplete: EddyAutoComplete<GrupoEstoque>;
  public subGrupoAutoComplete: EddyAutoComplete<SubGrupoEstoque>;
  public setorAutoComplete: EddyAutoComplete<Setor>
  public produtoAutoComplete: EddyAutoComplete<Produto>
  public planoContaAutoComplete: EddyAutoComplete<PlanoConta>;

  public imaskQtd = {
    mask: Number,
    scale: 0,
    signed: false
  };

  // ========================================================================
  // ------------------------------ CONSTRUTOR ------------------------------
  // ========================================================================

  constructor(
    protected funcaoService: FuncaoService,
    protected progressoService: ProgressoService,
    private saldoEstoqueService: SaldoEstoqueService,
    protected grupoService: GrupoEstoqueService,
    protected subGrupoService: SubGrupoEstoqueService,
    protected posicaoEstoqueService: PosicaoEstoqueService,
    protected produtoService: ProdutoService,
    private setorService: SetorService,
    private planoContaService: PlanoContaService) {
    super();
  }

  // ========================================================================
  // -------------------------- MÃ‰TODOS ABSTRAÃDOS --------------------------
  // ========================================================================

  protected afterInit(): void {
    this.orientacao = 'landscape';
    this.listaOrdenacao = this.obterColunasOrdenacoes();
    this.ordenacao = this.listaOrdenacao[0];
    this.listaTipo = this.obterColunasTipos();
    this.tipo = this.listaTipo[0];
    this.carregarAutoCompletes();
  }

  protected tituloRelatorio(): string {
    return this.login.orgao.nome;
  }

  protected subTituloRelatorio(): string {
    const local = `${this.login.setorAlmoxarifado.estoque.nome} - ${this.geralEstoque ? 'TODOS OS ESTOQUES' : (this.geral ? 'TODOS OS SETORES' : this.setor ? this.setor.nome : this.login.setorAlmoxarifado?.setor?.nome)}`;
    const filtroPlanoConta = this.planoConta
      ? `\nCONTA CONTÁBIL: ${this.planoConta.codigo} - ${this.planoConta.nome}`
      : '';

    return `POSIÇÃO DE ESTOQUE - PERÍODO ATÉ: ${new FuncaoService().converteDataBR(this.periodo)}\n${local}${filtroPlanoConta}`;
  }

  protected obterColunasRelatorio(): Coluna[] {
    let cols: Coluna[] = [
      { titulo: 'CÓDIGO', coluna: 'codigo', fontSize: 8, alignment: 'center', bold: false },
      { titulo: 'NOME', coluna: 'produto', fontSize: 8, alignment: 'left', bold: false },
      { titulo: 'SUB-GRUPO', coluna: 'subgrupo', fontSize: 8, alignment: 'left', bold: false },
      { titulo: 'UN.', coluna: 'unidade', fontSize: 8, alignment: 'center', bold: false },
      { titulo: 'MÁXIMO', coluna: 'maximo', fontSize: 8, alignment: 'center', bold: false },
      { titulo: 'MÍNIMO', coluna: 'minimo', fontSize: 8, alignment: 'center', bold: false },
      { titulo: 'SALDO MATERIAL', coluna: 'saldo', fontSize: 8, alignment: 'center', bold: false, decimais: 4 },
      { titulo: 'ÚLTIMA ENTRADA', coluna: 'ultima_entrada', fontSize: 8, alignment: 'center', bold: false, decimais: 4 },
      { titulo: 'CUSTO MÉDIO', coluna: 'custo_medio', fontSize: 8, alignment: 'center', bold: false, decimais: 4 },
      { titulo: 'VALOR TOTAL', coluna: 'valor_total', fontSize: 8, alignment: 'center', bold: false, decimais: 2 },
    ];

    if (this.analitico) {
      cols.splice(2, 0, { titulo: 'SETOR', coluna: 'setor', fontSize: 8, alignment: 'left', bold: false });
    }

    if (this.exibirLoteValidade) {
      cols.push({ titulo: 'LOTE', coluna: 'lote', fontSize: 8, alignment: 'center', bold: false });
      cols.push({ titulo: 'VALIDADE', coluna: 'vencimento', fontSize: 8, alignment: 'center', bold: false })
    }

    return cols;
  }

  protected larguraColunas(): (string | number)[] {
    let cols = ['auto', '*', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto'];
    if (this.analitico) {
      cols.splice(2, 0, '*');
    }
    if (this.exibirLoteValidade) {
      cols.push('auto');
      cols.push('auto');
    }
    return cols;
  }

  protected totalizarColunas(): (string | {})[] {
    return ["valor_total"];
  }

  protected async carregarLista(): Promise<any[]> {
    if (!this.validar())
      return;

    let setorId
    setorId = this.setor ? this.setor.id : this.login.setorAlmoxarifado.setor.id;

    let produtosId = []
    if (this.filtrarProdutos && this.listaProduto?.length) {
      if (this.listaProduto?.length > 0) {
        for (const p of this.listaProduto) {
          produtosId.push(`${p.id}`);
        }
      }
    }

    const dados = await this.posicaoEstoqueService.filtrar(1, 1,
      {
        relations: 'setor_almoxarifado,setor_almoxarifado.estoque,produto_unidade,produto_unidade.produto'
      }).toPromise();
    let data2 = null;
    if (dados.content.length > 0) {
      data2 = dados.content[0].data_cadastro;
    }

    return new Promise((resolve) => {
      this.saldoEstoqueService.posicaoEstoque(
        this.geralEstoque ? null : this.login.setorAlmoxarifado.estoque.id,
        this.periodo,
        this.tipo.coluna,
        this.ordenacao.coluna,
        {
          grupo: this.geralEstoque || !this.filtrarGrupo ? null : this.grupo?.id,
          subgrupo_id: this.filtrarSubGrupo ? this.subGrupo?.id : null,
          exibir_lote: this.exibirLoteValidade,
          produtos: produtosId,
          planoContaCodigo: this.filtrarPlanoConta ? this.planoConta?.codigo || '' : '',
          utilizarGrupoSubgrupo: this.filtrarSubGrupo && this.utilizarGrupoSubgrupo,
          analitico: this.geral && this.analitico,
        },
        this.geral ? null : setorId,
        data2,
        this.login.orgao.id
      )
        .pipe(takeUntil(this.unsubscribe))
        .subscribe(data => {
          let dados;
          this.progressoService.show(data, async (retorno) => {
            dados = retorno
            if (!dados.length) {
              toastr.warning('Não foram encontrados dados relacionados a busca!');
              return false;
            }
            resolve(dados.map((d) => {
              d['valor_total'] = +d.custo_medio * +d.saldo;
              if (!d['valor_total'])
                d['valor_total'] = 0;
              return d;
            }));
            // return dados
          });
        }, (error) => toastr.error(error.error.payload));
    });
  }

  private carregarAutoCompletes() {
    this.grupoAutoComplete = new EddyAutoComplete(null, this.grupoService,
      'id', ['codigo', 'nome'], { orgao_id: this.login.orgao?.id, orderBy: 'nome', relations: 'estoques.grupo' }, { number: ['codigo'], text: ['nome'] }
    );

    this.subGrupoAutoComplete = new EddyAutoComplete(null, this.subGrupoService,
      'id', ['codigo', 'nome'], { orgao_id: this.login.orgao.id, orderBy: 'nome' }, { number: ['codigo'], text: ['nome'] }
    );

    this.setorAutoComplete = new EddyAutoComplete(null, this.setorService,
      'id', ['codigo', 'nome'], { orgao_id: this.login.orgao.id, relations: 'orgao', orderBy: 'nome' }, { text: ['nome', 'codigo'] }
    );

    this.produtoAutoComplete = new EddyAutoComplete(
      null,
      this.produtoService,
      'id',
      ['codigo', 'nome'],
      { orgao_id: this.login.orgao.id, orderBy: 'codigo,nome' },
      { number: ['codigo'], text: ['codigo', 'nome'] },
      () => {
        if (
          this.produto &&
          !this.listaProduto.find(set => set.id == this.produto.id) &&
          this.listaProduto.length < 10
        ) {
          this.listaProduto.push({ ...this.produto });
        }
        this.produto = new Produto();
        this.produtoAutoComplete.id = null;
      },
      null,
    );

    this.planoContaAutoComplete = new EddyAutoComplete(null, this.planoContaService,
      'id', ['codigo', 'nome'], { 'exercicio.id': this.login.exercicio.id, orderBy: 'codigo' }, { number: ['codigo'], text: ['nome'] }
    );

  }

  // ========================================================================
  // -------------------------- MÉTODOS DA CLASSE ---------------------------
  // ========================================================================

  public obterColunasOrdenacoes(): { nome: string, coluna: string }[] {
    return [
      { coluna: 'codigo', nome: 'Código' },
      { coluna: 'grupo', nome: 'Grupo de Material' },
      { coluna: 'produto', nome: 'Produto' },
      { coluna: 'subgrupo', nome: 'Sub-Grupo' },
      { coluna: 'lote_vencimento', nome: 'Lote, Vencimento' },
      { coluna: 'vencimento_lote', nome: 'Vencimento, Lote' }
    ];
  }

  public obterColunasTipos(): { nome: string, coluna: string }[] {
    return [
      { coluna: 'mov_estoque', nome: 'Movimentados' },
      { coluna: 'com_saldo', nome: 'Com Saldo' },
      { coluna: 'todos', nome: 'Todos' },
    ];
  }

  public desabilitarExibirLote() {
    if (this.exibirLoteValidade) {
      this.ordenacao = this.listaOrdenacao[0];

    }
  }

  public onChangeFiltrarGrupo(): void {
    if (!this.filtrarGrupo) {
      this.grupo = null;
    }
  }

  public onChangeFiltrarSubGrupo(): void {
    if (!this.filtrarSubGrupo) {
      this.subGrupo = null;
      this.utilizarGrupoSubgrupo = false;
    }
  }

  public onChangeFiltrarPlanoConta(): void {
    if (!this.filtrarPlanoConta) {
      this.planoConta = null;
    }
  }

  public onChangeFiltrarProdutos(): void {
    if (!this.filtrarProdutos) {
      this.produto = null;
      this.listaProduto = [];
      if (this.produtoAutoComplete) {
        this.produtoAutoComplete.id = null;
      }
    }
  }

  public onChangeFiltrarSetor(): void {
    if (!this.filtrarSetor) {
      this.setor = null;
    }
  }

  public onChangeGeral(): void {
    if (!this.geral) {
      this.analitico = false;
    }
  }


  private validar(): boolean {
    if (!this.periodo) {
      toastr.warning('Informe a data limite para emissão do relatorio!');
      return false;
    }
    return true;
  }

  public onHide() {
    this.visualizar = false;
    this.visualizarChange.emit(this.visualizar);
  }

  public removerProduto(indice: number) {
    if (indice > -1) {
      this.listaProduto.splice(indice, 1);
    }
  }
}
